import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps, Tooltip } from '@mui/material';
import { ReactElement, ReactNode, cloneElement } from 'react';


type IconButtonProps<C extends React.ElementType = React.ElementType> = MuiIconButtonProps<C, { component?: C }> & {
    tooltip?: ReactNode;
    children: ReactElement;
}

export function IconButton({
    children, tooltip, className, ...props
}: IconButtonProps) {
    return (
        <Tooltip title={tooltip}>
            <span className={className}>
                <MuiIconButton {...props}>
                    {cloneElement(children, props.disabled ? { color: 'disabled' } : undefined)}
                </MuiIconButton>
            </span>
        </Tooltip>
    );
}
